import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-pd-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8c141.8 0 248.4 110.1 248.4 248 0 147.1-118.5 248-248.4 248-134 0-247.6-109.5-247.6-248 0-132.9 104.7-248 247.6-248zM248.4 458.8c103.2 0 202.8-81.1 202.8-202.8 0.1-113.8-90.2-203.3-202.8-203.3-118.2 0-203.7 97.9-203.7 203.3 0 109.8 91.2 202.8 203.7 202.8zM316.7 186c21.4 0 70 5.2 70 68.6 0 63.5-48.6 68.6-70 68.6h-53.2v-137.2h53.2zM317.5 294.5c24 0 34.5-15.3 34.5-39.9 0-42-31.2-39.9-35-39.9l-19.4 0.1v79.7h19.9zM203.7 186c33.7 0 50.5 15.5 50.5 46.5 0 9-3 46.5-57.1 46.5h-27v44.3h-34.6v-137.3h68.2zM198.8 253.3c27.9 0 30-41.6-0.9-41.6h-28.3v41.6h29.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-pd-alt.js
// module id = 771
// module chunks = 0